import { render, staticRenderFns } from "./RouteEdit.vue?vue&type=template&id=4b066700"
import script from "../../controllers/route/route-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/route/route-edit.js?vue&type=script&lang=js&external"
import style0 from "./RouteEdit.vue?vue&type=style&index=0&id=4b066700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports